import { KeyValue } from '@angular/common';
import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { ServiceordreDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceordre-dto';
import { OpgaveEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/opgave-enum';
import { ChangeOrdreOpgaveTypeRequest } from 'src/app/api/models/OK/Egis/Service/Models/Request/change-ordre-opgave-type-request';
import { ServiceordreService } from 'src/app/api/services';
import { ChangeOpgaveTypeDialogData } from 'src/app/components/aftale/models';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
    selector: 'app-change-order-type-dialog',
    templateUrl: './change-order-type-dialog.component.html',
    styleUrls: ['./change-order-type-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangeOrderTypeDialogComponent implements OnInit {
  form: UntypedFormGroup;
  serviceOrder: ServiceordreDto;
  serviceOrdreNo: number;
  opgaveType: OpgaveEnum;
  opgaveTyper: string[];
  unsubscribe$ = new Subject<void>();

  constructor(
    private fb: UntypedFormBuilder,
    private loader: LoaderService,
    private serviceOrdreService: ServiceordreService,
    private errorHandler: ErrorHandlerService,
    private dialog: MatDialogRef<ChangeOrderTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeOpgaveTypeDialogData
  ) {
    this.opgaveType = data.opgaveType;
    this.serviceOrdreNo = data.serviceOrdreNo;
    //Filter existing, and unwanted types
    this.opgaveTyper = Object.keys(OpgaveEnum).filter((x) => x != OpgaveEnum.NotSet && x != OpgaveEnum.Opfoelgning && x != this.opgaveType);
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      newOpgaveType: new UntypedFormControl(null, Validators.required),
    });
  }

  onOpgaveTypeChange(id: string): void {
    this.opgaveType = OpgaveEnum[id];
  }

  cancel() {
    this.dialog.close(null);
  }

  save() {
    const request: ChangeOrdreOpgaveTypeRequest = {
      serviceordreNo: this.serviceOrdreNo,
      newOpgaveType: this.form.controls.newOpgaveType.value,
    };

    this.serviceOrdreService
      .changeOpgaveType({ body: request, caller: EGIS_SERVICE_CALLER })
      .pipe(
        takeUntil(this.unsubscribe$),
        finalize(() => {
          this.loader.hide();
        })
      )
      .subscribe(
        (response) => {
          this.dialog.close(response);
        },
        (error) => {
          this.errorHandler.HandleError(error);
        }
      );

    this.loader.show();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }
}
